module.exports = __webpack_public_path__ + "img/Module-Page-Top-Wireframe.f2c1c6b4.svg";